@if (downloadLinks) {
<div class="font-outfit font-bold text-base text-center">
    like the app?
    <p class="gradient-text font-semibold text-4xl">download</p>
</div>
<div class="flex flex-col justify-center px-4 sm:px-0 sm:flex-row gap-[30px] mt-[58px]">
    @if (downloadLinks.apple) {
    <img (click)="goTo(downloadLinks.apple)" src="/images/download-buttons/apple.svg" alt="">
    }
    @if (downloadLinks.google) {
    <img (click)="goTo(downloadLinks.apple)" src="/images/download-buttons/google.svg" alt="">
    }
</div>
}